/**
 * 
 * @param {string} name 
 * @returns 
 */

const url = `app`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`

export const LOAD_MONTHLY_RECORD = `${url}/LOAD_MONTHLY_RECORD`
export const LOAD_MONTHLY_RECORD_SUCCESS = `${url}/LOAD_MONTHLY_RECORD_SUCCESS`
export const LOAD_MONTHLY_RECORD_ERROR = `${url}/LOAD_MONTHLY_RECORD_ERROR`

export const LOAD_CHECKINOUT = `${url}/LOAD_CHECKINOUT`
export const LOAD_CHECKINOUT_SUCCESS = `${url}/LOAD_CHECKINOUT_SUCCESS`
export const LOAD_CHECKINOUT_ERROR = `${url}/LOAD_CHECKINOUT_ERROR`

export const LOAD_ATTENDENCE = `${url}/LOAD_ATTENDENCE`
export const LOAD_ATTENDENCE_SUCCESS = `${url}/LOAD_ATTENDENCE_SUCCESS`
export const LOAD_ATTENDENCE_ERROR = `${url}/LOAD_ATTENDENCE_ERROR`

const constants = {
 
  LOAD_MONTHLY_RECORD,
  LOAD_MONTHLY_RECORD_SUCCESS,
  LOAD_MONTHLY_RECORD_ERROR,

  LOAD_CHECKINOUT,
  LOAD_CHECKINOUT_SUCCESS,
  LOAD_CHECKINOUT_ERROR,

  LOAD_ATTENDENCE,
  LOAD_ATTENDENCE_SUCCESS,
  LOAD_ATTENDENCE_ERROR,
  
  LOAD_RECORDS_VALID_CACHE

}

export default constants
